<template>
  <el-dialog
    title="Verify Information"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-click-modal="false"
    custom-class="auth-basic-dialog"
    v-loading="allLoading"
  >
    <div class="info-list" v-loading="loading">
      <div class="info-tip">{{L.pleaseReview}}</div>
      <template v-if="loaded">
        <div class="info-row">
          <span class="label">{{L.companyName}}:</span>
          <span class="value">{{obj.dealerName || '-'}}</span>
        </div>
        <div class="info-row">
          <span class="label">{{L.companyID}}:</span>
          <span class="value">{{obj.taxNumber || '-'}}</span>
        </div>
        <div class="info-row">
          <span class="label">{{L.legalPersonName}}:</span>
          <span class="value">{{obj.legalName || '-'}}</span>
        </div>
      </template>
    </div>
    <div slot="footer" class="dialog-footer">
      <div class="dialog-cancel" @click="close">{{L.cancel}}</div>
      <div class="dialog-select" @click="handleConfirm">{{L.confirm}}</div>
    </div>
  </el-dialog>
</template>

<script>
import {api_auth_info,api_start_verify} from '@/api/api'
import {postAction} from '@/api/tool'

export default {
  name:'Basic',
  data(){
    return {
      visible:false,
      loading:false,
      loaded:false, //数据到位后置 true，触发 v-if 渲染 + 逐行 CSS 动画
      obj:{
        dealerName:'',
        taxNumber:'',
        legalName:''
      }
    }
  },
  methods:{
    /* 打开弹窗：不再从外部接收数据，改为内部调 api_auth_info 拉取(需求3) */
    open(){
      this.visible=true
      this.loaded=false
      this.getInfo()
    },
    close(){
      this.visible=false
    },
    /* 拉取认证信息作为 4 个字段来源；成功后置 loaded 触发逐行动画(需求3+4) */
    getInfo(){
      this.loading=true
      postAction(api_auth_info).then(res=>{
        this.loading=false
        this.obj = res || {}
        this.$nextTick(()=>{
          this.loaded=true
        })
      }).catch(()=>{
        this.loading=false
      })
    },
    /* 需求6：confirm 方法先不写 */
    handleConfirm(){
      this.allLoading=true
      postAction(api_start_verify,{}).then(res=>{
        this.allLoading=false
        if(res.authUrl){
          this.close()
          this.$emit('afterClickVerify')
          window.open(res.authUrl)
        }else{
          this.$message.error(res.message)
        }
      }).catch(()=>{
        this.allLoading=false
      })
    }
  }
}
</script>

<style lang="less">
@import url('/public/css/public.less');
/*
  照抄 EndCustomer.vue 骨架：append-to-body 弹窗的 Element 内部节点(.el-dialog__header/__body/__footer)
  被搬到 body 下、不带组件 data-v，scoped 命中不到，故整块走非 scoped 全局样式，并收在独立命名空间
  custom-class="auth-basic-dialog" 下(命名空间独立，避免污染 EndCustomer 等其它弹窗)。
  居中：absolute + top/left:50% + translate(-50%,-50%) + margin:0!important(盖 Element 内联 margin-top)。
*/
.auth-basic-dialog{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,.3);
  .el-dialog__header{
    border-bottom: 1px solid @darkBorderColor;
    flex-shrink: 0;
    padding: 16px;
    text-align: left;
    box-sizing: border-box;
    .el-dialog__title{
      line-height: 24px;
      font-size: 17px;
      color: @mainFontColor;
      font-weight: 600;
    }
    .el-dialog__headerbtn{
      top: 16px;
      right: 16px;
      .el-dialog__close{
        color: @inpNumColor;
        font-weight: 600;
      }
      &:hover .el-dialog__close{ color: @tableNoAndBtnColor; }
    }
  }
  .el-dialog__body{
    flex: 1;
    min-height: 0;
    padding: 8px 24px 20px;
    font-size: 13px;
    color: @mainFontColor;
  }
  .el-dialog__footer{
    flex-shrink: 0;
    padding: 16px;
    text-align: right;
    box-sizing: border-box;
    background-color: @darkBgcColor;
  }
  /* ===== 组件自身模板元素 ===== */
  .info-list{
    text-align: left;
    min-height: 132px; /* 加载态占位，避免数据到位前后弹窗高度跳动 */
    .info-tip{
      margin:10px 0;
      color:@mainColor;
    }
    .info-row{
      display: flex;
      align-items: center;
      padding: 13px 0;
      font-size: 13px;
      border-bottom: 1px solid @inpBorderClolr;
      /* 逐行动画：初始透明，fadeInUp 上浮淡入，forwards 保持结束态 */
      opacity: 0;
      animation: basicFadeInUp 0.45s ease forwards;
      &:last-child{ border-bottom: none; }
      .label{
        width: 160px;
        flex-shrink: 0;
        text-align: left;
        color: @inpNumColor;
      }
      .value{
        flex: 1;
        text-align: left;
        font-weight: 600; /* 需求2：加粗展示值 */
        color: @mainFontColor;
        word-break: break-all;
      }
      /* 需求4：stagger 延迟，4 行依次流畅浮现 */
      &:nth-child(1){ animation-delay: 0.06s; }
      &:nth-child(2){ animation-delay: 0.18s; }
      &:nth-child(3){ animation-delay: 0.30s; }
      &:nth-child(4){ animation-delay: 0.42s; }
    }
  }
  /* 底部 Cancel/Confirm 用全局公共类 .dialog-cancel/.dialog-select(public2.less)，此处只留右对齐 */
  .dialog-footer{
    text-align: right;
  }
}
@keyframes basicFadeInUp{
  from{ opacity: 0; transform: translateY(12px); }
  to{ opacity: 1; transform: translateY(0); }
}
</style>
